import { render, staticRenderFns } from "./RredEnvelopeDetail.vue?vue&type=template&id=d4aface2&scoped=true&"
import script from "./RredEnvelopeDetail.vue?vue&type=script&lang=js&"
export * from "./RredEnvelopeDetail.vue?vue&type=script&lang=js&"
import style0 from "./RredEnvelopeDetail.vue?vue&type=style&index=0&id=d4aface2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4aface2",
  null
  
)

export default component.exports